export const tListOfTables = [
  {
    caption: "INVENTORY",
    key: "-MESPxTjVmc7yGcRzTCZ",
    menu: "INVENTORY",
    name: "inventory"
  },
  {
    caption: "PURCHASE",
    key: "-MAt7wQodmOn3zkcbYn0",
    menu: "PURCHASE",
    name: "purchase"
  },
  {
    caption: "SOURCE SUPPLIER",
    menu: "SOURCE SUPPLIR",
    name: "sourceSupplier",
    key: "-M9wSYEqew_khvMeny2j"
  },
  {
    caption: "APP PHOTOS",
    key: "-M9rtsy-MvKtsLkpkCWg",
    menu: "APP PHOTOS",
    name: "appPhotos"
  },
  {
    caption: "SUPPLIER",
    menu: "SUPPLIER",
    name: "dqr",
    key: "-M97w7q92MbnSQuc4Y2P"
  },
  {
    caption: "BCS HOME",
    menu: "BCS HOME",
    name: "bcsHome",
    updateDateTime: "26/05/2020 08:15:00",
    key: "-M8CtnxbMWDVSrp1DFvw"
  },
  {
    caption: "OPEN BAZAR",
    key: "-M809q9K3KcbiL02k6bO",
    menu: "OPEN BAZAR",
    name: "openBazar"
  },
  {
    caption: "RIZI TEST",
    key: "-M7joh6NZutkn-61UBGS",
    menu: "RIZI MENU",
    name: "riziTest"
  },
  {
    caption: "MY SHOP",
    key: "-M7Xa21919ZTFYbeP4fR",
    menu: "MY SHOP",
    name: "supplierShopItems"
  },
  {
    caption: "ORDERS",
    key: "-M5tSI70237W5vV7YYh5",
    menu: "ORDERS",
    name: "deliveryRequest"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "CREATE FORM",
    createDateTime: "",
    key: "32",
    menu: "CREATE FORM",
    name: "formDefinitions",
    updateDateTime: "15/03/2020 04:14:42"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "CREATE TABLE",
    createDateTime: "",
    key: "30",
    menu: "CREATE TABLE",
    name: "listOfTables",
    updateDateTime: "15/03/2020 04:15:03"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "CREATE MENU",
    createDateTime: "",
    key: "28",
    menu: "CREATE MENU",
    name: "menuDesigner",
    updateDateTime: "15/03/2020 04:15:38"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "USERS",
    createDateTime: "",
    key: "19",
    menu: "USER",
    name: "users",
    updateDateTime: "15/03/2020 06:21:07"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "DASHBOARD",
    createDateTime: "",
    key: "18",
    menu: "DASHBOARD",
    name: "dashboard",
    updateDateTime: "15/03/2020 06:21:47"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "SIGN OUT",
    createDateTime: "",
    key: "16",
    menu: "SIGN OUT",
    name: "signout",
    updateDateTime: "15/03/2020 06:26:34"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "LIST OF TABLES",
    createDateTime: "",
    key: "15",
    menu: "LIST OF TABLES",
    name: "listOfTables",
    updateDateTime: "15/03/2020 06:26:49"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "CREATE FORM",
    createDateTime: "",
    key: "10",
    menu: "CREATE FORM",
    name: "createTable",
    updateDateTime: "15/03/2020 07:51:10"
  },
  { caption: "ACCOUNTS", key: "5", menu: "ACCOUNTS", name: "accounts" },
  {
    caption: "PAYMENT TYPES",
    key: "4",
    menu: "PAYMENT TYPES",
    name: "paymentTypes"
  },
  { caption: "ACCT ENTRY", key: "3", menu: "ACCT ENTRY", name: "bookKeeping" },
  { caption: "EXPENSE", key: "2", menu: "EXPENSE", name: "expense" },
  {
    caption: "BOOK KEEPING",
    key: "1",
    menu: "BOOK KEEPING",
    name: "accountingEntry"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "ACCOUNT ENQUIRIES",
    createDateTime: "",
    key: "0",
    menu: "ACCOUNT ENQUIRY",
    name: "accountEnquiry",
    updateDateTime: "26/04/2020 01:33:03"
  }
];



// WEBPACK FOOTER //
// ./src/staticData/tListOfTables.js